import { cpf as validacpf, cnpj as validacnpj } from 'cpf-cnpj-validator';
import moment from 'moment';
import { validate as validaemail } from 'email-validator';
import { passwordStrength } from 'check-password-strength';
import { isValidURL } from '../../../helpers/validacoes';

export const validacao = (values, campos = [], trad, trads, lingua, desconsiderarcampos = {}) => {
    let errors = {};
    
    //CONF EMAIL e SENHA
    if(!desconsiderarcampos.confemail){
        if (values.email !== values.confemail) {
            errors.confemail = trad(trads, 'JSCONFDADOS', lingua);
        }

        if (values.senha !== values.confsenha) {
            errors.confsenha = trad(trads, 'JSCONFDADOS', lingua);
        }
    }

    //website
    /*if(values.website&&!isValidURL(values.website)){
        errors.website = trad(trads, 'JSINVALIDO', lingua);
    }*/

    //data
    if(values.nascimento&&!moment(values.nascimento, 'DD/MM/YYYY',true).isValid()){
        errors.nascimento = trad(trads, 'JSINVALIDO', lingua);
    }

    //Senha Verificação
    if(!desconsiderarcampos.senha){
        if(passwordStrength(values.senha).id < 1 || values.senha.length<8){
            errors.senha = trad(trads, 'JSSENHAFRACA', lingua);
        }
    }

    //Valida CPF                    
    if (values.cpf) {
        let cpf_number = values.cpf.replaceAll('.', '');
        cpf_number = cpf_number.replaceAll('/', '');
        cpf_number = cpf_number.replaceAll('-', '');
        cpf_number = cpf_number.replaceAll(' ', '');
        if (!validacpf.isValid(cpf_number)) {
            errors.cpf = trad(trads, 'JSINVALIDO', lingua);
        }
    }

    //Valida CNPJ                    
    if (values.cnpj) {
        let cnpj_number = values.cnpj.replaceAll('.', '');
        cnpj_number = cnpj_number.replaceAll('/', '');
        cnpj_number = cnpj_number.replaceAll('-', '');
        cnpj_number = cnpj_number.replaceAll(' ', '');
        if (!validacnpj.isValid(cnpj_number)) {
            errors.cnpj = trad(trads, 'JSINVALIDO', lingua);
        }
    }

    //Valida CNPJ                    
    if (values.email) {
        if (!validaemail(values.email)) {
            errors.email = trad(trads, 'JSINVALIDO', lingua);
        }
    }

    campos.map(campo => {
        const campotratado = campo.name.replaceAll('_','');
        if (!values[campotratado] && !desconsiderarcampos[campotratado]){            
            if(campo.obrigatorio === true && campo.ocultacampo === false){
                errors[campotratado] = trad(trads, 'JSOBRIGATORIO', lingua);
            }
        }

        if (campo.perguntasobrigatorias&&campo.perguntasobrigatorias.length) {
            const perguntas = campo.perguntasobrigatorias;
            perguntas.map(pergunta => {
                if (pergunta && !values[`p_${pergunta}`]) {
                    errors[`p_${pergunta}`] = trad(trads, 'JSOBRIGATORIO', lingua);
                }
                return null;
            })
        }
        return null;
    })
    
    return errors;
}

export const getCamposCssObrigatorios = (campos) => {
    let css = {};
        
    if(campos&&campos.length){
        campos.map(itens => {                    
            css = {
                ...css,
                [itens.name]: {                            
                    display: itens.ocultacampo?'none':'',
                    textDecorationLine: itens.obrigatorio?'underline':'none',
                    textDecorationColor: itens.obrigatorio?'red':'none',
                    textDecorationStyle: itens.obrigatorio?'dotted':'none'
                }
            }

            if(itens.perguntasobrigatorias&&itens.perguntasobrigatorias.length){
                itens.perguntasobrigatorias.map(pergs => {                            
                    css = {
                        ...css,
                        [`p_${pergs}`]: {
                            textDecorationLine: 'underline',
                            textDecorationColor: 'red',
                            textDecorationStyle: 'dotted'               
                        }

                    }
                    return null;
                });
            }

            return null;
        });
    }

    return css;
}